import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteHtml = function SvgRteHtml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.98 7.196a1 1 0 00-1.96-.392l-2 10a1 1 0 101.96.392l2-10zM8.8 8.4a1 1 0 01-.2 1.4L5.667 12 8.6 14.2a1 1 0 01-1.2 1.6l-4-3a1 1 0 010-1.6l4-3a1 1 0 011.4.2zM15.2 15.6a1 1 0 01.2-1.4l2.933-2.2L15.4 9.8a1 1 0 111.2-1.6l4 3a1 1 0 010 1.6l-4 3a1 1 0 01-1.4-.2z"
  })));
};
var rteHtml = SvgRteHtml;

export { rteHtml as default };
